// Centralized refund status constants for consistent mappings across the application

/**
 * Complete mapping of refund status IDs to display labels
 */
export const REFUND_STATUS_LABELS = {
  1: 'Eligible',
  2: 'Request Scheduled',
  3: 'Refund Pending',
  4: 'Refunded',
  5: 'Refund Canceled',
  6: 'Refund Rejected',
  7: 'Disabled',
};

/**
 * Status IDs that should display as visual tags (actionable states)
 * Excludes initial/system states like "Eligible" and "Disabled"
 */
export const REFUND_TAG_STATUS_IDS = [2, 3, 4, 5, 6];

/**
 * Mapping from refund status ID to CSS class name for styling
 */
export const REFUND_STATUS_TO_CSS_CLASS = {
  1: 'refundeligible',
  2: 'refundscheduled',
  3: 'refundpending',
  4: 'refunded',
  5: 'refundcanceled',
  6: 'refundrejected',
  7: 'refunddisabled',
};

/**
 * Helper function to get display label for a refund status ID
 * @param {number} statusId - The refund status ID
 * @returns {string} The display label or '-' if not found
 */
export const getRefundStatusLabel = (statusId) => {
  if (statusId === null || statusId === undefined) return '-';
  return REFUND_STATUS_LABELS[statusId] || '-';
};

/**
 * Helper function to get CSS class for a refund status ID
 * @param {number} statusId - The refund status ID
 * @returns {string|null} The CSS class name or null if not found
 */
export const getRefundStatusCssClass = (statusId) => {
  return REFUND_STATUS_TO_CSS_CLASS[statusId] || null;
};

/**
 * Check if a status ID should display as a visual tag
 * @param {number} statusId - The refund status ID
 * @returns {boolean} True if should show tag, false otherwise
 */
export const shouldShowRefundTag = (statusId) => {
  return REFUND_TAG_STATUS_IDS.includes(statusId);
};
